import React, { useContext, useState } from 'react';
import { withRouter } from 'react-router-dom';
import { makeStyles } from '@material-ui/core/styles';
import { UsersContext } from '../../../contexts/UsersContext';
import { Button, Table, Loader } from '../../../components';


const columns = [
  { id: 'email', label: 'Email', sortable: true },
  { id: 'createdAt', label: 'Created At', sortable: true },
  { id: 'status', label: 'Status' },
  { id: 'actions' },
];

const useStyles = makeStyles((theme) => ({
  editButton: {
    marginRight: '2%',
  },
}));

const UsersTable = (props) => {
  const { actions } = useContext(UsersContext);

  const [statusLoaders, setStatusLoaders] = useState({});

  const classes = useStyles();

  const rows = props.users.map((user) => {
    return {
      ...user,
      createdAt: new Date(user.createdAt).toLocaleDateString(),
      actions: (
        <>
          <Button
            variant="outlined"
            classes={{root: classes.editButton}}
            onClick={() => {
              props.history.push(`/users/${user._id}/edit`);
            }}
          >
            edit
          </Button>
          <Button
            variant="outlined"
            disabled={statusLoaders[user._id]}
            onClick={async () => {
              const newLoader = {};
              newLoader[user._id] = true;
              setStatusLoaders({ ...statusLoaders, ...newLoader });
              await actions.toggleStatus(user);
              newLoader[user._id] = false;
              setStatusLoaders({ ...statusLoaders, ...newLoader });
            }}
          >
            {statusLoaders[user._id] ? <Loader /> : null}
            {user.status === 'active' ? 'deactivate' : 'activate'}
          </Button>
        </>
      ),
    };
  });

  return <Table columns={columns} rows={rows} keyField={'_id'} />;
};

export default withRouter(UsersTable);
